import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';

import { useLocation } from 'react-router';
import { setAuthToken } from '../api/utils';
import { getUserPermissionsAgain } from '../screens/auth/actions';
import {
    getAuthToken,
    getUserPermissionRoleId,
    getUserPermissionState,
    isUserLoggedIn,
    getViewAsPartner,
    getUser,
} from '../screens/auth/selectors';

function CheckForPermissions({
    user,
    children,
    isLoading,
    isUserLoggedIn,
    authToken,
    roleId,
    viewAsPartner,
}) {
    const location = useLocation();
    const { roles } = user;

    const dispatch = useDispatch();
    if (isUserLoggedIn) setAuthToken(authToken);

    React.useEffect(() => {
        if (!isLoading) dispatch(getUserPermissionsAgain());
    }, [location]);

    if (!viewAsPartner) {
        if (
            !isLoading &&
            !(roles || []).map((item) => item.roleId).includes(roleId)
        ) {
            return (
                <div className="admin-flow-box content-users">
                    <div className="card-header">
                        You do not have the permissions to see this area, please
                        logout and log back in.
                    </div>
                </div>
            );
        }
    }

    return children;
}

CheckForPermissions.propTypes = {
    children: PropTypes.array,
    isLoading: PropTypes.bool,
    isUserLoggedIn: PropTypes.bool,
    authToken: PropTypes.string,
    roleId: PropTypes.number,
    viewAsPartner: PropTypes.bool,
    user: PropTypes.object,
};

CheckForPermissions.defaultProps = {
    children: null,
    isLoading: null,
    isUserLoggedIn: null,
    authToken: null,
    roleId: null,
    viewAsPartner: null,
    user: null,
};

const mapStateToProps = (state) => {
    return {
        isLoading: getUserPermissionState(state),
        isUserLoggedIn: isUserLoggedIn(state),
        authToken: getAuthToken(state),
        user: getUser(state),
        roleId: getUserPermissionRoleId(state),
        viewAsPartner: getViewAsPartner(state),
    };
};

export default connect(mapStateToProps)(CheckForPermissions);
